<template>
    <div class="organization-merge">
        <div v-if="organizationOne && organizationTwo" class="organization-merge-org">
            <div v-for="field in organizationFields.filter(f =>organizationOne[f] !== organizationTwo[f] &&(organizationOne[f]?.trim() || organizationTwo[f]?.trim()))" :key="field" class="organization-merge-org-field">
                <div class="organization-merge-org-name">{{organizationFieldNames[field]}}</div>
                <div class="org-value" :class="{'org-value-selected':useOneField[field]}">{{organizationOne[field]}}</div>
                <div @click="useOneField[field]=!useOneField[field]" class="material-symbols-outlined">{{useOneField[field]?'arrow_back':'arrow_forward'}}</div>
                <div class="org-value" :class="{'org-value-selected':!useOneField[field]}">{{organizationTwo[field]}}</div>
                <div></div>
            </div>
        </div>
        <div style="display: grid; grid-template-rows: minmax(0,1fr);">
            <DxDataGrid :data-source="allContacts"
                        :pager="{enabled:false}"
                        height="100%"
                        :editing="{mode:'cell',allowUpdating:true}"
                        :scrolling="{useNative: true, mode:'virtual'}"
                        @toolbar-preparing="$root.addGridTitle($event,'Ansprechpartner Duplikate')">
                <DxColumn data-field="salutationId" :allow-editing="false" cell-template="salutationTemplateView" caption="Anrede" />
                <template #salutationTemplateView="{ data: cellInfo }">
                    <ListLookup list="contact_salutation" :value="cellInfo.value" :on-value-changed="cellInfo.setValue" :view="true"></ListLookup>
                </template>
                <DxColumn data-field="_id" :visible="false" :allowSearch="false"></DxColumn>
                <DxColumn data-field="selected" :allow-editing="false" caption="Auswahl" cell-template="checkboxTemplate" width="100" />
                <template #checkboxTemplate="{ data: cellInfo }">
                    <input type="checkbox"
                           v-model="cellInfo.data.selected"
                           @change="updateSelection(cellInfo)"
                           :disabled="cellInfo.data.externalId !== null" />
                </template>
                <DxColumn data-field="firstName" :allow-editing="false" caption="Vorname" />
                <DxColumn data-field="lastName" :allow-editing="false" caption="Nachname" />
                <DxColumn data-field="eMail" :allow-editing="false" caption="E-Mail" />
                <DxColumn data-field="dupedId"  :lookup="{dataSource: availableContacts,valueExpr: '_id',displayExpr: (e)=>e.firstName+' '+e.lastName}" caption="Projekte übergeben an" />
                <DxColumn data-field="projectCount" :allow-editing="false" caption="Projekte" />
                <DxColumn data-field="externalId" :allow-editing="false" caption="Aus Vertec" :calculate-cell-value="e=>!!e.externalId" />
                <DxSearchPanel :visible="true" />
            </DxDataGrid>
        </div>
        <div class="merge_button">
            <DxButton icon="save" :text="'Zusammenführen'" @click="showMergePopup = true"></DxButton>
        </div>
        <div>
            <DxPopup :visible="showMergePopup"
                     :show-title="true"
                     title="Datenänderung bestätigen"
                     :width="400"
                     :height="200"
                     :drag-enabled="true"
                     :close-on-outside-click="true"
                     @hiding="showMergePopup = false">
                <div>Es werden {{ selectedCount() }} Personen übernommen und {{ unselectedCount() }} Personen gelöscht.</div>
                <DxToolbarItem widget="dxButton"
                               toolbar="bottom"
                               location="after">
                    <DxButton width="129" text="Bestätigen" @click="saveMerge"></DxButton>
                </DxToolbarItem>
            </DxPopup>
        </div>

    </div>
</template>

<script lang="js">

    import { defineComponent } from 'vue';
    import organizationApi from '../services/OrganizationApi';
    import DxButton from 'devextreme-vue/button';
    import DxDataGrid, {
        DxColumn,
        DxSearchPanel
    } from 'devextreme-vue/data-grid';
    import ListLookup from '../components/list-lookup.vue';
    import {
        DxPopup, DxToolbarItem
    } from 'devextreme-vue/popup';
import projectApi from '../services/ProjectApi';
import { afterProcessingAsync, processor } from '../services/Processor';
    export default defineComponent({
        components: {
            DxButton,
            DxDataGrid,
            ListLookup,
            DxColumn,
            DxSearchPanel,
            DxPopup,
            DxToolbarItem
        },
        props: {
            'organizationIdOne': String,
            'organizationIdTwo': String
        },
        watch: {
            allContacts(u) {
                let available = u.filter(n => n.selected);
                available.unshift({_id:null,firstName:'Keine',lastName:'Zuweisung'})
                this.availableContacts = available;
            }
        },
        data() {
            let fields = {
                name: "Name",
                city: "Stadt",
                eMail: "E-Mail",
                streetAndNr: "Straße / Nr.",
                zipCode: "PLZ"
            };
            return {
                availableContacts: [],
                useOneField: Object.fromEntries(Object.keys(fields).map(f=>[f,true])),
                organizationFieldNames: fields,
                organizationFields: Object.keys(fields),
                organizationOne: null,
                organizationTwo: null,
                organizationContactsOne: null,
                involvedOne: null,
                involvedTwo: null,
                contactDuplicate: [],
                allContacts: [],
                showMergePopup: false,
            };
        },
        async created() {
            await this.loadOrganizations();
            this.organizationContactsOne = await organizationApi.getOrganizationContacts(this.organizationIdOne);
            let organizationContactsTwo = await organizationApi.getOrganizationContacts(this.organizationIdTwo);
            this.involvedOne = await organizationApi.getProjectsInvolved(this.organizationIdOne);
            this.involvedTwo = await organizationApi.getProjectsInvolved(this.organizationIdTwo);
            let all = []
            all.push(...this.organizationContactsOne)
            all.push(...organizationContactsTwo)
            this.allContacts = all;
            console.log(this.involvedOne)
            console.log(this.involvedTwo)


            this.checkDuplicates();
            for (let contact of this.allContacts) {    
                if (!contact.projects)
                    contact.projects = new Set();
                for (let i of this.involvedOne.filter(p => p?.involvedContacts?.some(i => i.contactId == contact._id)).map(p => p._id))
                    contact.projects.add(i)
                for (let i of this.involvedTwo.filter(p => p?.involvedContacts?.some(i => i.contactId == contact._id)).map(p => p._id))
                    contact.projects.add(i)
                contact.projectCount = contact.projects.size

            }
            

            console.log("allContacts",this.allContacts)
            /*
            let allSearchResults = await this.findDuplicateContacts(organizationContactsOne, this.organizationIdTwo);

            allSearchResults.push(...await this.findContactsInSameOrganization(organizationContactsOne, this.organizationIdOne));
            allSearchResults.push(...await this.findContactsInSameOrganization(organizationContactsTwo, this.organizationIdTwo));

            console.log("Final3 allSearchResults", allSearchResults)
            this.processDuplicateContacts(allSearchResults);
            */
        },
        methods: {
            cleanEquals(s1, s2) {
                return this.cleanString(s1) == this.cleanString(s2)
            },
            cleanString(s) {
                return s?.trim()?.toLowerCase();
            },
            checkDuplicates() {
                for (let contact of this.allContacts) {
                    console.log("contact.externalId", contact.externalId);
                    contact.selected = !contact.isDupe;
                    if (contact.externalId != null) {
                        contact.selected = true;
                    }
                    if (contact.isDupe)
                        continue;
                    let nameDupes = this.allContacts.filter(c => this.cleanEquals(c.firstName, contact.firstName) && this.cleanEquals(c.lastName, contact.lastName) && c._id != contact._id);
                    for (let dupe of nameDupes) {
                        dupe.isDupe = true;
                        dupe.dupedId = contact._id;
                    }
                    let eMailDupes = this.allContacts.filter(c => c.eMail && this.cleanEquals(c.eMail, contact.eMail) && c._id != contact._id);
                    for (let dupe of eMailDupes) {
                        dupe.isDupe = true;
                        dupe.dupedId = contact._id;
                    }
                }
            },
            async saveMerge() {
                console.log(this.organizationIdOne)
                let org = structuredClone(await organizationApi.get(this.organizationIdOne));

                for (let field of this.organizationFields) {
                    let value = this.useOneField[field] ? this.organizationOne[field] : this.organizationTwo[field];
                    org[field] = value;
                    console.log("[merge] field ", field, value);
                }
                let extId = this.organizationOne.externalId || this.organizationTwo.externalId;
                if (extId)
                    org.externalId = extId;
                await organizationApi.save(org);

                let existingContactIds = new Set(this.organizationContactsOne.map(contact => contact._id));

                let newContacts = this.allContacts.filter(e => e.selected === true && !existingContactIds.has(e._id));
                console.log("Neue Kontakte, die hinzugefügt werden:", newContacts);
                for (let contact of newContacts) {
                    contact.organizationId = this.organizationIdOne
                    let dupeIds = this.allContacts.filter(c => c.dupedId == contact._id);
                    let newContact = await organizationApi.saveContact(contact);
                    dupeIds.forEach(d => d.dupedId = newContact._id);
                }

                for (let ic of this.involvedTwo) {                    
                    let project = structuredClone(await projectApi.get(ic._id));
                    if (project.buildingOwnerOrganizationId == this.organizationIdTwo)
                        project.buildingOwnerOrganizationId = this.organizationIdOne;
                    if (project.clientOrganizationId == this.organizationIdTwo)
                        project.clientOrganizationId = this.organizationIdOne
                    if (project.architectOrganizationId == this.organizationIdTwo)
                        project.architectOrganizationId = this.organizationIdOne

                    let involvedContactsToChange = project.involvedContacts.filter(pi => pi.organizationId == this.organizationIdTwo);
                    for (let involvedContact of involvedContactsToChange) {
                        involvedContact.organizationId = this.organizationIdOne;
                    }
                    await projectApi.save(project);
                }

                await organizationApi.delete(this.organizationIdTwo)

                let removeContacts = this.allContacts.filter(e => e.selected === false);
                console.log("Neue Kontakte, die entfernt werden:", removeContacts);
                for (let contact of removeContacts) {
                    for (let projectId of contact.projects) {
                        let project = structuredClone(await projectApi.get(projectId));
                        if (project.buildingOwnerId == contact._id)
                            project.buildingOwnerId = contact.dupedId
                        if (project.clientId == contact._id)
                            project.clientId = contact.dupedId
                        if (project.architectId == contact._id)
                            project.architectId = contact.dupedId
                        if (contact.dupedId && !project.involvedContacts.find(pi => pi.contactId == contact.dupedId)) {
                            // TRANSFER
                            let toRemoveProjectInvolved = project.involvedContacts.find(pi => pi.contactId == contact._id);
                            toRemoveProjectInvolved.contactId = contact.dupedId;
                            toRemoveProjectInvolved.organizationId = this.organizationIdOne;
                            console.log("transfered", toRemoveProjectInvolved);
                        } else {
                            // REMOVE FROM INVOLVED
                            project.involvedContacts = project.involvedContacts.filter(pi => pi.contactId != contact._id)
                            console.log("removed", project.involvedContacts);
                        }
                        await projectApi.save(project);
                    }
                    await organizationApi.deleteContact(contact._id);
                }


                console.log("Zusammengeführte Daten:", processor);
                if (processor.isDirty.value)
                    await afterProcessingAsync()
                location.href = "/MainData/Organizations/" + this.organizationIdOne;
                location.reload()
                this.showMergePopup = false;
            },
            async loadOrganizations() {
                this.organizationOne = await organizationApi.get(this.organizationIdOne);
                this.organizationTwo = await organizationApi.get(this.organizationIdTwo);
                for (let field of Object.keys(this.useOneField) ){
                    if (!this.organizationOne[field] && this.organizationTwo[field]) {
                        this.useOneField[field] = false;
                    }
                }
                console.log("organizationOne", this.organizationOne);
                console.log("organizationTwo", this.organizationTwo);
            },
            checkboxTemplate(e) {
                return e;
            },
            updateSelection(e) {
                console.log(e);
            },
            selectedCount() {
                let contact = this.allContacts;
                console.log("contact", contact);
                return contact.filter(e => e.selected).length;
            },
            unselectedCount() {
                let contact = this.allContacts;
                return contact.filter(e => !e.selected).length;
            }
        }
    });
</script>

<style scoped>
    .organization-merge {
        display: grid;
        grid-template-rows: max-content minmax(0, 1fr) max-content max-content;
        height: 100%;
    }
    .organization-merge-org-name{
        text-align: right;
    }
    .organization-merge-org-field {
        display: grid;
        grid-template-columns: subgrid;
        grid-column: span 4;
        gap: 12px;
        padding: 10px;
        border-radius: 8px;
        background: rgba(0, 0, 0, 0.02);
        align-items: center;
    }

    .organization-merge-org {
        display: grid;
        grid-template-columns: 1fr max-content max-content max-content 1fr;
        grid-gap: 10px;
        margin-bottom: 40px;
    }

    .org-value {
        padding: 5px 10px;
        border: 1px solid #eee;
        height: 32px;
    }

    .org-value-selected {
        border: 1px solid var(--color-accent);
    }

    .merge_button {
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
    }
</style>
